const EXCLUDED_PATTERNS = [
  /\.doc$/i, /\.docx$/i, /\.db$/i, /^Thumbs/i,
  /01-Ingredient Handling/i,
  /Flour Application & Recycling System/i,
  /AMF Method Client Tutorial Package/i,
  /Interactive AMFMethod Training/i
];

const ALLOWED_EXTENSIONS = [
  // Documents
  '.pdf', '.xls', '.xlsx', '.ppt', '.pptx', '.rtf', '.odt', '.ods', '.odp', '.csv',
  // Images
  '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp', '.tiff', '.ico',
  // Video
  '.mp4', '.avi', '.mov', '.mkv', '.wmv', '.flv', '.webm', '.m4v',
  // Audio
  '.mp3', '.wav', '.aac', '.flac', '.ogg', '.wma', '.m4a',
  // Web
  '.html', '.htm', '.css', '.js', '.json', '.xml',
  // Archives
  '.zip', '.rar', '.7z', '.tar', '.gz',
  // Executables & Scripts
  '.exe', '.msi', '.bat', '.sh', '.py','.mpg',
  // CAD / Engineering
  '.dwg', '.dxf', '.step', '.stp', '.igs', '.stl',
];

// Visible file types in the directory tree (documents, excel, videos)
export const VISIBLE_EXTENSIONS = [
  '.pdf', // documents & excel
  '.mp4', // videos
];

export const isVisibleFile = (name) => {
  if (!name) return false;
  const lower = name.toLowerCase();
  return VISIBLE_EXTENSIONS.some(ext => lower.endsWith(ext));
};

const FOLDER_RENAME_MAP = {
  'C-VBT': 'Basic Video Based Training',
  'B-CBT': 'Basic Computer Based Training',
  'Online': 'Basic Computer Based Training'
};

export const shouldExclude = (name) => EXCLUDED_PATTERNS.some(pattern => pattern.test(name));
export const isAllowedFile = (name) => ALLOWED_EXTENSIONS.some(ext => name.toLowerCase().endsWith(ext));
export const renameFolderForDisplay = (name) => FOLDER_RENAME_MAP[name] || name;

/**
 * Build tree node from backend folder data
 * @param {Object} data - { directories: [{name, path}], files: [{name, path}] }
 * @param {string} currentPath - Current path being processed (e.g., "historical-content/folder1")
 * @param {string} displayName - Optional display name for the node
 * @returns {Object} Tree node with children
 */
export const buildTreeNode = (data, currentPath, displayName) => {

  // Normalize path: remove trailing slash
  const normalizedPath = currentPath.replace(/\/$/, "");
  
  // FIXED: Handle both old format (string arrays) and new format (object arrays)
  const directoriesData = data.directories || [];
  const filesData = data.files || [];
  
  // Process directories
  const directories = directoriesData
    .filter(d => {
      const name = typeof d === 'string' ? d : d.name;
      // FIXED: Filter out empty/blank names
      if (!name || name.trim() === '') {
        console.warn(`Skipping directory with empty name:`, d);
        return false;
      }
      return !shouldExclude(name);
    })
    .map(d => {
      // Handle both string and object formats
      const dirName = typeof d === 'string' ? d : d.name;
      const dirPath = typeof d === 'string' 
        ? (normalizedPath ? `${normalizedPath}/${dirName}` : dirName)
        : d.path;
      
      return {
        id: dirPath,
        name: renameFolderForDisplay(dirName),
        type: 'folder',
        path: dirPath,
        children: [] // Empty array, will be populated on expand
      };
    });

  // Process files (only visible types)
  const files = filesData
    .filter(f => {
      const name = typeof f === 'string' ? f : f.name;
      // Filter out empty/blank names
      if (!name || name.trim() === '') {
        console.warn(`Skipping file with empty name:`, f);
        return false;
      }
      // Only include files considered visible (documents, excel, videos)
      return isVisibleFile(name);
    })
    .map(f => {
      // Handle both string and object formats
      const fileName = typeof f === 'string' ? f : f.name;
      const filePath = typeof f === 'string'
        ? (normalizedPath ? `${normalizedPath}/${fileName}` : fileName)
        : f.path; // Use the full blob path from backend
      
      return {
        id: filePath,
        name: fileName,
        type: 'file',
        path: filePath // This is the actual blob path in Azure
      };
    });

  if (directories.length > 0) {
  }
  if (files.length > 0) {
  }

  return {
    id: normalizedPath,
    name: displayName || currentPath.split('/').pop() || currentPath,
    type: 'folder',
    path: normalizedPath,
    children: [...directories, ...files]
  };
};
